import PropTypes from "prop-types";
import React from "react";
import UserFoundContent from "../components/UserFoundContent";
import { useStylesPage } from "../utils/mantine/useStylesPage";
import { Flex, useMantineTheme } from "@mantine/core";

const UserFound = ({ staticBasePath }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  //css classes
  const { classes: classesPage } = useStylesPage();
  return (
    <>
      <title>vBase Verify App</title>
      <meta
        name="description"
        content="Use vBase Verify to quickly and easily verify stamps!"
      />
      <meta property="og:title" content="vBase Verify App" />
      <meta
        property="og:description"
        content="Use vBase Verify to quickly and easily verify stamps!"
      />

      <Flex
        className={`${classesPage.page} ${classesPage.pageUserFound}`}
        direction="column"
        align={theme.flex.align.center}
      >
        <UserFoundContent staticBasePath={staticBasePath} />
      </Flex>
    </>
  );
};
UserFound.propTypes = {
  staticBasePath: PropTypes.object.isRequired,
  djangoContext: PropTypes.object.isRequired,
};
export default UserFound;
